export default __webpack_public_path__ + "static/media/Performance-mareting-img2.c22e3f0d.png";